import { RESERVED_DESTINATION_SLUGS, type ApiErrorCode, type ApiErrorParams } from "@ckgo2/shared";
import i18n, { uiLocale } from "@/i18n";

/**
 * Text kódu chyby API ve slovníku aktivního jazyka adminu (vize F13.9) — JEDINÉ místo
 * překladu kódu: volá ho API klient (horní chyby) i `humanizeFieldMessage` (chyby u polí).
 *
 * `slug_reserved` jde po drátě bez parametru; výčet vyhrazených slugů do textu dosadí admin
 * z téže sdílené konstanty, kterou kontroluje Zod schéma. `when` (čas souběžné změny u
 * `conflict`) přijde jako ISO řetězec a zobrazí se v národním formátu jazyka adminu.
 */
export function apiErrorText(code: ApiErrorCode, params?: ApiErrorParams): string {
  const values: ApiErrorParams = { ...params };
  if (code === "slug_reserved" && values.slugs === undefined) {
    values.slugs = RESERVED_DESTINATION_SLUGS.join(", ");
  }
  if (typeof values.when === "string" && !Number.isNaN(Date.parse(values.when))) {
    values.when = new Date(values.when).toLocaleString(uiLocale());
  }
  const key = `apiErrors.${code}` as const;
  return i18n.t(key, values);
}
